<svg class="d-none">
  <symbol id="qa-app" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256">
    <path d="M232 96a16 16 0 0 0-16-16h-32V48a16 16 0 0 0-16-16H40a16 16 0 0 0-16 16v128a7.9 7.9 0 0 0 4.6 7.2a8.1 8.1 0 0 0 3.4.8a7.7 7.7 0 0 0 5-1.8L72 154v30a16 16 0 0 0 16 16h93.6l37.4 30.2a7.8 7.8 0 0 0 8.4 1a7.9 7.9 0 0 0 4.6-7.2ZM66.6 137.8L40 159.2V48h128v88H71.6a7.7 7.7 0 0 0-5 1.8Zm122.8 48a7.7 7.7 0 0 0-5-1.8H88v-32h80a16 16 0 0 0 16-16V96h32v111.2Z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="settings-4" preserveAspectRatio="xMidYMid meet" viewBox="0 0 36 36">
    <path class="clr-i-solid clr-i-solid-path-1"
          d="M32.57 15.72l-3.35-1a11.65 11.65 0 0 0-.95-2.33l1.64-3.07a.61.61 0 0 0-.11-.72l-2.39-2.4a.61.61 0 0 0-.72-.11l-3.05 1.63a11.62 11.62 0 0 0-2.36-1l-1-3.31a.61.61 0 0 0-.59-.41h-3.38a.61.61 0 0 0-.58.43l-1 3.3a11.63 11.63 0 0 0-2.38 1l-3-1.62a.61.61 0 0 0-.72.11L6.2 8.59a.61.61 0 0 0-.11.72l1.62 3a11.63 11.63 0 0 0-1 2.37l-3.31 1a.61.61 0 0 0-.43.58v3.38a.61.61 0 0 0 .43.58l3.33 1a11.62 11.62 0 0 0 1 2.33l-1.64 3.14a.61.61 0 0 0 .11.72l2.39 2.39a.61.61 0 0 0 .72.11l3.09-1.65a11.65 11.65 0 0 0 2.3.94l1 3.37a.61.61 0 0 0 .58.43h3.38a.61.61 0 0 0 .58-.43l1-3.38a11.63 11.63 0 0 0 2.28-.94l3.11 1.66a.61.61 0 0 0 .72-.11l2.39-2.39a.61.61 0 0 0 .11-.72l-1.66-3.1a11.63 11.63 0 0 0 .95-2.29l3.37-1a.61.61 0 0 0 .43-.58v-3.41a.61.61 0 0 0-.37-.59zM18 23.5a5.5 5.5 0 1 1 5.5-5.5a5.5 5.5 0 0 1-5.5 5.5z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="calendar-date" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M7 12h2v2H7v-2m14-6v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V2h2v2h8V2h2v2h1a2 2 0 0 1 2 2M5 8h14V6H5v2m14 12V10H5v10h14m-4-6v-2h2v2h-2m-4 0v-2h2v2h-2m-4 2h2v2H7v-2m8 2v-2h2v2h-2m-4 0v-2h2v2h-2z"
      fill="currentColor"></path>
  </symbol>
  <symbol height="20.625" id="new-calendar-date" viewBox="0 0 22 20.625" width="22" xmlns="http://www.w3.org/2000/svg">
    <svg height="20.625" viewBox="0 0 22 20.625" width="22" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar-line" transform="translate(-2 -2)">
        <path d="M22.8,6H20.562V7.375h2.062V22.5H3.375V7.375H5.437V6H3.2A1.224,1.224,0,0,0,2,7.244V22.63a1.224,1.224,0,0,0,1.2,1.244H22.8A1.224,1.224,0,0,0,24,22.63V7.244A1.224,1.224,0,0,0,22.8,6Z" data-name="Path 104"
              fill="#38cff9"
              id="Path_104" transform="translate(0 -1.25)"/>
        <path d="M8,14H9.375v1.375H8Z" data-name="Path 105" fill="#38cff9" id="Path_105"
              transform="translate(-1.875 -3.75)"/>
        <path d="M14,14h1.375v1.375H14Z" data-name="Path 106" fill="#38cff9" id="Path_106"
              transform="translate(-3.75 -3.75)"/>
        <path d="M20,14h1.375v1.375H20Z" data-name="Path 107" fill="#38cff9" id="Path_107"
              transform="translate(-5.625 -3.75)"/>
        <path d="M26,14h1.375v1.375H26Z" data-name="Path 108" fill="#38cff9" id="Path_108"
              transform="translate(-7.5 -3.75)"/>
        <path d="M8,19H9.375v1.375H8Z" data-name="Path 109" fill="#38cff9" id="Path_109"
              transform="translate(-1.875 -5.313)"/>
        <path d="M14,19h1.375v1.375H14Z" data-name="Path 110" fill="#38cff9" id="Path_110"
              transform="translate(-3.75 -5.313)"/>
        <path d="M20,19h1.375v1.375H20Z" data-name="Path 111" fill="#38cff9" id="Path_111"
              transform="translate(-5.625 -5.313)"/>
        <path d="M26,19h1.375v1.375H26Z" data-name="Path 112" fill="#38cff9" id="Path_112"
              transform="translate(-7.5 -5.313)"/>
        <path d="M8,24H9.375v1.375H8Z" data-name="Path 113" fill="#38cff9" id="Path_113"
              transform="translate(-1.875 -6.875)"/>
        <path d="M14,24h1.375v1.375H14Z" data-name="Path 114" fill="#38cff9" id="Path_114"
              transform="translate(-3.75 -6.875)"/>
        <path d="M20,24h1.375v1.375H20Z" data-name="Path 115" fill="#38cff9" id="Path_115"
              transform="translate(-5.625 -6.875)"/>
        <path d="M26,24h1.375v1.375H26Z" data-name="Path 116" fill="#38cff9" id="Path_116"
              transform="translate(-7.5 -6.875)"/>
        <path d="M9.687,7.5a.687.687,0,0,0,.687-.687V2.687A.687.687,0,0,0,9,2.687V6.812A.687.687,0,0,0,9.687,7.5Z" data-name="Path 117"
              fill="#38cff9"
              id="Path_117" transform="translate(-2.188)"/>
        <path d="M25.687,7.5a.687.687,0,0,0,.687-.687V2.687a.687.687,0,0,0-1.375,0V6.812A.687.687,0,0,0,25.687,7.5Z" data-name="Path 118"
              fill="#38cff9"
              id="Path_118" transform="translate(-7.188)"/>
        <path d="M13,6h6.875V7.375H13Z" data-name="Path 119" fill="#38cff9" id="Path_119"
              transform="translate(-3.438 -1.25)"/>
      </g>
    </svg>

  </symbol>
  <symbol height="11.778" id="blue-search-icon" viewBox="0 0 11.777 11.778" width="11.777"
          xmlns="http://www.w3.org/2000/svg">
    <path d="M17149.4,6748.382l-3.039-3.039a4.819,4.819,0,1,0-.758.758l3.041,3.038a.533.533,0,0,0,.756,0A.535.535,0,0,0,17149.4,6748.382Zm-6.8-2.3a3.748,3.748,0,1,1,3.75-3.748A3.746,3.746,0,0,1,17142.6,6746.083Z" data-name="search 1 copy 2"
          fill="#01c9ff"
          id="search_1_copy_2" transform="translate(-17137.781 -6737.518)"/>
  </symbol>
  <symbol aria-hidden="true" fill="currentColor" id="select-arrows" viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
    <path clip-rule="evenodd"
          d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="none" id="ac-copy-link" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>
  <symbol id="t-sort-up" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20">
    <g fill="none">
      <path
        d="M9.75 3c.235 0 .452.108.59.278l2.94 2.945a.75.75 0 0 1 0 1.061a.748.748 0 0 1-1.058 0L10.5 5.566V16.25a.75.75 0 0 1-1.5 0V5.556L7.278 7.289a.748.748 0 0 1-1.059 0a.75.75 0 0 1 0-1.061L9.223 3.22A.731.731 0 0 1 9.75 3z"
        fill="currentColor"></path>
    </g>
  </symbol>
  <symbol id="t-sort-down" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <g fill="none">
      <path
        d="M11.883 4.01L12 4.003a1 1 0 0 1 .993.884l.007.116v11.584l2.293-2.294a1 1 0 0 1 1.32-.084l.094.084a1 1 0 0 1 .084 1.32l-.084.094l-3.996 4a1 1 0 0 1-1.32.084l-.094-.084l-4.004-4a1 1 0 0 1 1.32-1.498l.094.084L11 16.582V5.003a1 1 0 0 1 .883-.993L12 4.003l-.117.007z"
        fill="currentColor"></path>
    </g>
  </symbol>
  <symbol id="t-sort-icon" preserveAspectRatio="xMidYMid meet" viewBox="0 0 28 28">
    <g fill="none">
      <path
        d="M8.352 4.011l.058-.007L8.5 4l.075.003l.126.017l.111.03l.111.044l.098.052l.104.074l.082.073l5.5 5.5a1 1 0 0 1-1.32 1.497l-.094-.083L9.5 7.415V23a1 1 0 0 1-1.993.117L7.5 23V7.415l-3.793 3.792a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094l5.5-5.5a1.01 1.01 0 0 1 .112-.097l.11-.071l.114-.054l.105-.035l.118-.025zM19.5 4a1 1 0 0 1 .993.883L20.5 5v15.585l3.793-3.792l.094-.083a1 1 0 0 1 1.403 1.403l-.083.094l-5.5 5.5l-.044.041l-.068.056l-.11.071l-.114.054l-.105.035l-.117.025l-.09.01h-.118l-.06-.006l-.114-.02l-.109-.033l-.081-.034l-.098-.052l-.096-.067a1.01 1.01 0 0 1-.09-.08l-5.5-5.5l-.083-.094a1 1 0 0 1 0-1.226l.083-.094l.094-.083a1 1 0 0 1 1.226 0l.094.083l3.793 3.792V5l.007-.117A1 1 0 0 1 19.5 4z"
        fill="currentColor"></path>
    </g>
  </symbol>
  <symbol id="sp-drag" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M9 3h2v2H9V3m4 0h2v2h-2V3M9 7h2v2H9V7m4 0h2v2h-2V7m-4 4h2v2H9v-2m4 0h2v2h-2v-2m-4 4h2v2H9v-2m4 0h2v2h-2v-2m-4 4h2v2H9v-2m4 0h2v2h-2v-2z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="sp-filter" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512">
    <path d="M96 197.333h320v32H96z" fill="currentColor"></path>
    <path d="M168 298.667h176v32H168z" fill="currentColor"></path>
    <path d="M216 400h80v32h-80z" fill="currentColor"></path>
    <path d="M48 96h416v32H48z" fill="currentColor"></path>
  </symbol>
  <symbol id="increase" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M13 8v3H3v2h10v3l4-4l-4-4m6 12h2V4h-2v16z" fill="currentColor"></path>
  </symbol>
  <symbol id="decrease" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M11 16v-3h10v-2H11V8l-4 4l4 4m-8 4h2V4H3v16z" fill="currentColor"></path>
  </symbol>
  <symbol id="section-1" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 20 20">
    <g fill="none">
      <path d="M6 4.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5z" fill="currentColor"></path>
      <path d="M6 9.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" fill="currentColor"></path>
      <path d="M6.5 14a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6z" fill="currentColor"></path>
      <path
        d="M2.854 7.732a.5.5 0 1 0-.708.707L3.207 9.5l-1.06 1.06a.5.5 0 1 0 .707.708l1.414-1.414a.5.5 0 0 0 0-.708L2.854 7.732z"
        fill="currentColor"></path>
    </g>
  </symbol>
  <symbol fill="none" id="section" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6h16M4 12h16m-7 6h7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
  </symbol>
  <symbol fill="none" id="arrow-right" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M5 12h14m-7-7l7 7-7 7"/>
  </symbol>
  <symbol id="move-icon" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M19.299 10.957l-1.121-1.121a1 1 0 1 1 1.414-1.415l2.828 2.829a1 1 0 0 1 0 1.414l-2.828 2.828a1 1 0 0 1-1.414-1.414l1.121-1.121h-6.485v6.485l1.121-1.121a1 1 0 0 1 1.414 1.414l-2.828 2.829a1 1 0 0 1-1.414 0l-2.829-2.829a1 1 0 0 1 1.414-1.414l1.122 1.121v-6.485H4.328l1.122 1.121a1 1 0 0 1-1.414 1.414l-2.829-2.828a1 1 0 0 1 0-1.414l2.829-2.83A1 1 0 0 1 5.45 9.836l-1.122 1.12h6.486V4.473l-1.122 1.12a1 1 0 0 1-1.414-1.414l2.829-2.829a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 1 1-1.414 1.414l-1.121-1.121v6.485h6.485z"
      fill="currentColor"></path>
  </symbol>
  <symbol fill="currentColor" id="chevron-right" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="currentColor" id="chevron-left" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="none" id="arrow-line-right" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <line x1="5" x2="19" y1="12" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </symbol>
  <symbol fill="none" id="assignment" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path d="M14 2v6h6m-4 5H8m8 4H8m2-8H8"/>
  </symbol>
  <symbol fill="none" id="calendar" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
  </symbol>
  <symbol id="check-circle" viewBox="0 0 24 24">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <path d="M22 4L12 14.01l-3-3"/>
  </symbol>
  <symbol class="feather feather-chevron-up" fill="none" id="arrow-up" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <polyline points="18 15 12 9 6 15"></polyline>
  </symbol>
  <symbol fill="none" id="award" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <circle cx="12" cy="8" r="7"/>
    <path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"/>
  </symbol>
  <symbol fill="none" id="play" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10"></circle>
    <polygon points="10 8 16 12 10 16 10 8"></polygon>
  </symbol>

  <symbol enable-background="new 0 0 100 100" fill="currentColor"
          id="average" viewBox="0 0 100 100">
    <g>
      <path d="M95,24.852H5v20.149h44.875H95V24.852z M91,41.001H9V28.852h82V41.001z"/>
      <path
        d="M49.875,75.251H65l-15.125-30.25L34.75,75.251H49.875z M58.528,71.251h-8.653h-8.653l8.653-17.306L58.528,71.251z"/>
    </g>
  </symbol>

  <symbol class="feather feather-bookmark" fill="none" id="bookmark-outline" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
  </symbol>

  <symbol class="css-i6dzq1" fill="none" id="enrolled" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="12" x2="12" y1="18" y2="12"></line>
    <line x1="9" x2="15" y1="15" y2="15"></line>
  </symbol>

  <symbol fill="currentColor" id="bookmark-filled" viewBox="0 0 24 24">
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
  </symbol>
  <symbol class="feather feather-x" fill="none" id="close" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <line x1="18" x2="6" y1="6" y2="18"></line>
    <line x1="6" x2="18" y1="6" y2="18"></line>
  </symbol>

  <symbol id="close-wo" viewBox="0 0 24 24">
    <path
      d="M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z"
    />
  </symbol>

  <symbol fill="currentColor" id="dashboard" viewBox="0 0 24 24">
    <g>
      <path d="m7.323 10.5h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
    <g>
      <path d="m19.323 10.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
    <g>
      <path d="m7.323 14.5h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
    <g>
      <path d="m19.323 14.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
    <g>
      <path d="m7.323 18.5h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
    <g>
      <path d="m19.323 18.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
    <g>
      <path
        d="m21.25 23h-18.5c-1.517 0-2.75-1.233-2.75-2.75v-16.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v16.5c0 1.517-1.233 2.75-2.75 2.75zm-18.5-20.5c-.689 0-1.25.561-1.25 1.25v16.5c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25v-16.5c0-.689-.561-1.25-1.25-1.25z"/>
    </g>
    <g>
      <path d="m23.25 6h-22.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h22.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/>
    </g>
  </symbol>
  <symbol fill="none" id="content-file" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <g id="content-file">
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
      <path d="M13 2v7h7"/>
    </g>
  </symbol>
  <symbol id="content-file-1" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 24 24">
    <path d="M5 2.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4H5zm10 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5zM3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3z"
          fill="currentColor"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="none" id="content-htmlpage" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M16 18l6-6-6-6M8 6l-6 6 6 6"/>
  </symbol>
  <symbol fill="none" id="content-page" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M16 18l6-6-6-6M8 6l-6 6 6 6"/>
  </symbol>
  <symbol fill="none" id="content-weburl" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </symbol>
  <symbol fill="none" id="content-url" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </symbol>
  <symbol fill="currentColor" id="content-video" viewBox="0 0 24 24">
    <path
      d="M21 7.15a1.7 1.7 0 0 0-1.85.3l-2.15 2V8a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-1.45l2.16 2a1.74 1.74 0 0 0 1.16.45 1.68 1.68 0 0 0 .69-.15 1.6 1.6 0 0 0 1-1.48V8.63A1.6 1.6 0 0 0 21 7.15zM15 16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1zm5-1.4L17.19 12 20 9.4z"/>
  </symbol>
  <symbol id="course" viewBox="0 0 24 24">
    <path
      d="M20 13.18h-4.06l2.3-2.47a1 1 0 0 0 0-1.41l-4.19-3.86a.93.93 0 0 0-.71-.26 1 1 0 0 0-.7.31l-1.82 2V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v13.09A3.91 3.91 0 0 0 6.91 21H20a1 1 0 0 0 1-1v-5.82a1 1 0 0 0-1-1zm-6.58-5.59l2.67 2.49-5.27 5.66v-5.36zM8.82 10v3H5v-3zm0-5v3H5V5zM5 17.09V15h3.82v2.09a1.91 1.91 0 0 1-3.82 0zM19 19h-8.49l3.56-3.82H19z"/>
  </symbol>
  <symbol fill="none" id="minus" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 12H4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
  </symbol>
  <symbol fill="currentColor" id="delete-close" viewBox="0 0 24 24">
    <path d="M18 6L6 18M6 6l12 12"/>
  </symbol>
  <svg fill="none" id="x-circle" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </svg>
  <symbol fill="none" id="delete-trash" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </symbol>
  <symbol fill="currentColor" id="star" viewBox="0 0 20 20">
    <path
      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
  </symbol>

  <symbol id="no-asset" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <g fill="none">
      <path
        d="M18.75 3A3.25 3.25 0 0 1 22 6.25v11.5A3.25 3.25 0 0 1 18.75 21H5.25A3.25 3.25 0 0 1 2 17.75V6.25A3.25 3.25 0 0 1 5.25 3h13.5zm0 1.5H5.25A1.75 1.75 0 0 0 3.5 6.25v11.5c0 .966.784 1.75 1.75 1.75h13.5a1.75 1.75 0 0 0 1.75-1.75V6.25a1.75 1.75 0 0 0-1.75-1.75zm-12.002 2h10.506a.75.75 0 0 1 .102 1.493L17.254 8H6.748a.75.75 0 0 1-.101-1.493l.101-.007h10.506H6.748z"
        fill="currentColor"></path>
    </g>
  </symbol>
  <symbol id="collapse-all" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-1 7h-6v-2h6v2z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="expand-all" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-1 7h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
      fill="currentColor"></path>
  </symbol>

  <symbol id="expand-all-fill" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M18 8H8v10H6V8a2 2 0 0 1 2-2h10v2m-4-6H4a2 2 0 0 0-2 2v10h2V4h10V2m8 10v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m-2 3h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="collapse-all-fill" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M14 4H4v10H2V4a2 2 0 0 1 2-2h10v2m4 2H8a2 2 0 0 0-2 2v10h2V8h10V6m4 6v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m-2 3h-8v2h8v-2z"
      fill="currentColor"></path>
  </symbol>

  <symbol id="pin" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path
      d="M19 12.87c0-.47-.34-.85-.8-.98A2.997 2.997 0 0 1 16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.38-.93 2.54-2.2 2.89c-.46.13-.8.51-.8.98V13c0 .55.45 1 1 1h4.98l.02 7c0 .55.45 1 1 1s1-.45 1-1l-.02-7H18c.55 0 1-.45 1-1v-.13z"
      fill="currentColor" fill-rule="evenodd"></path>
  </symbol>
  <symbol id="unpin" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path
      d="M9 9l7 7h-3v4l-1 3l-1-3v-4H7a1 1 0 0 1-1-1v-1.586a1 1 0 0 1 .293-.707L9 10V9zm7-7a1 1 0 0 1 1 1v.382a1 1 0 0 1-.553.894L15 5v5l2.707 2.707a1 1 0 0 1 .293.707V15a.997.997 0 0 1-.076.383L12.27 9.73L9 6.46V5l-1.447-.724A1 1 0 0 1 7 3.382V3a1 1 0 0 1 1-1h8z"
      fill="currentColor"></path>
    <path
      d="M1.635 2.905a.9.9 0 0 0 0 1.27l18.19 18.19a.898.898 0 0 0 1.27-1.27L11 11L2.905 2.905a.898.898 0 0 0-1.27 0z"
      fill="currentColor"></path>
  </symbol>

  <symbol fill="none" id="external-link" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>
  <symbol fill="none" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    <line x1="10" x2="10" y1="11" y2="17"></line>
    <line x1="14" x2="14" y1="11" y2="17"></line>
  </symbol>

  <symbol id="menu_open" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M21 15.61l-1.406 1.406L14.578 12l5.016-5.016L21 8.391L17.437 12L21 15.61zM3 6h12.984v2.016H3V6zm0 6.984v-1.968h9.984v1.968H3zM3 18v-2.016h12.984V18H3z"
      fill="currentColor"></path>
  </symbol>

  <symbol id="expand-down" viewBox="0 0 24 24">
    <path d="M7 13l5 5 5-5M7 6l5 5 5-5"/>
  </symbol>
  <symbol fill="none" id="line-arrow-down" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M16 17l-4 4m0 0l-4-4m4 4V3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </symbol>

  <symbol fill="currentColor" id="queue" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path
      d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"/>
  </symbol>

  <symbol id="drag-reorder" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path
      d="M7 19v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2m-8-4v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2m-8-4V9h2v2H7m4 0V9h2v2h-2m4 0V9h2v2h-2M7 7V5h2v2H7m4 0V5h2v2h-2m4 0V5h2v2h-2z"
      fill="currentColor"></path>
  </symbol>

  <symbol fill="none" id="group" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"/>
  </symbol>
  <symbol fill="none" id="icon-user" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"/>
  </symbol>

  <symbol fill="currentColor" id="import" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path clip-rule="evenodd"
          d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
          fill-rule="evenodd"></path>
  </symbol>


  <symbol fill="none" id="stats" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>

  <symbol fill="currentColor" id="grid" viewBox="0 0 24 24">
    <path d="M3 3h7v7H3zm11 0h7v7h-7zm0 11h7v7h-7zM3 14h7v7H3z"/>
  </symbol>
  <symbol fill="none" id="filter" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          viewBox="0 0 24 24">
    <line x1="4" x2="4" y1="21" y2="14"></line>
    <line x1="4" x2="4" y1="10" y2="3"></line>
    <line x1="12" x2="12" y1="21" y2="12"></line>
    <line x1="12" x2="12" y1="8" y2="3"></line>
    <line x1="20" x2="20" y1="21" y2="16"></line>
    <line x1="20" x2="20" y1="12" y2="3"></line>
    <line x1="1" x2="7" y1="14" y2="14"></line>
    <line x1="9" x2="15" y1="8" y2="8"></line>
    <line x1="17" x2="23" y1="16" y2="16"></line>
  </symbol>

  <symbol fill="currentColor" id="view-grid" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path
      d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"/>
  </symbol>
  <symbol id="icon-assignment" viewBox="0 0 24 24">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect height="4" rx="1" ry="1" width="8" x="8" y="2"/>
  </symbol>
  <symbol id="icon-edit" viewBox="0 0 24 24">
    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </symbol>

  <symbol fill="none" id="edit-1" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M12 20h9"></path>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
  </symbol>

  <symbol id="ic-program" viewBox="0 0 24 24">
    <path d="M4 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
          fill="currentColor"/>
    <path clip-rule="evenodd" d="M3 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H3zm18 2H3a1 1 0 0 0-1 1v3h20V6a1 1 0 0 0-1-1zM2 18v-7h20v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
          fill="currentColor"
          fill-rule="evenodd"/>
  </symbol>
  <symbol fill="none" id="icon-program" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <rect height="14" rx="2" ry="2" width="20" x="2" y="3"/>
    <path d="M8 21h8m-4-4v4"/>
  </symbol>

  <symbol id="icon-program-1" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M21 16H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
          fill="currentColor"></path>
  </symbol>

  <symbol fill="none" id="icon-course" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24">
    <path
      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
  </symbol>

  <symbol fill="none" id="icon-module" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path
      d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
    <line x1="12" x2="12" y1="22.08" y2="12"></line>
  </symbol>

  <symbol id="icon-library" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
    <path d="M13 15v8l7-4l-7-4z" fill="currentColor"></path>
    <path
      d="M26 28H6a2.002 2.002 0 0 1-2-2V12a2.002 2.002 0 0 1 2-2h20a2.002 2.002 0 0 1 2 2v14a2.002 2.002 0 0 1-2 2zM6 12v14h20V12z"
      fill="currentColor"></path>
    <path d="M6 6h20v2H6z" fill="currentColor"></path>
    <path d="M8 2h16v2H8z" fill="currentColor"></path>
  </symbol>

  <symbol fill="none" id="icon-content"
          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          viewBox="0 0 20 20">
    <path
      d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"></path>
  </symbol>

  <symbol fill="none" height="24" id="icon-enrollments" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24" width="24">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" x2="8" y1="13" y2="13"></line>
    <line x1="16" x2="8" y1="17" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </symbol>

  <svg fill="none" id="sorting" stroke="currentColor"
       stroke-linecap="square"
       stroke-linejoin="miter"
       stroke-width="1.5"
       viewBox="0 0 24 24">
    <polyline points="8 8.333 12 4.333 16 8.333 16 8.333"></polyline>
    <polyline points="16 15.667 12 19.667 8 15.667 8 15.667"></polyline>
  </svg>

  <symbol id="log-out" viewBox="0 0 24 24">
    <path d="M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10"/>
  </symbol>
  <symbol fill="none" id="logout" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
  </symbol>
  <symbol fill="currentColor" id="view-list" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol id="list" viewBox="0 0 24 24">
    <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>
  </symbol>
  <symbol id="notifications" viewBox="0 0 24 24">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9m-4.27 13a2 2 0 0 1-3.46 0"/>
  </symbol>
  <symbol id="icon-notifications" viewBox="0 0 20 20">
    <path
      d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"></path>
  </symbol>
  <symbol id="icon-course" viewBox="0 0 24 24">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </symbol>
  <symbol fill="none" id="not-visible" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path
      d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line x1="1" x2="23" y1="1" y2="23"></line>
  </symbol>
  <symbol class="feather feather-unlock" fill="none" id="unlock" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <rect height="11" rx="2" ry="2" width="18" x="3" y="11"></rect>
    <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
  </symbol>

  <symbol class="feather feather-lock" fill="none" id="lock" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <rect height="11" rx="2" ry="2" width="18" x="3" y="11"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </symbol>
  <symbol fill="none" id="image-add" viewBox="0 0 24 24">
    <path clip-rule="evenodd" d="M22 14V5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V15V17C2 18.1 2.9 19 4 19H14"
          fill="transparent" fill-rule="evenodd"
          stroke="currentColor" stroke-width="1.5"></path>
    <path d="M22 14V5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V15V17C2 18.1 2.9 19 4 19H14" fill="transparent"
          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"></path>
    <path clip-rule="evenodd" d="M22 14L17 8L11 16L6 12L2 15V17C2 18.1 2.9 19 4 19H14" fill="transparent"
          fill-rule="evenodd" stroke="currentColor" stroke-width="1.5"></path>
    <path d="M22 14L17 8L11 16L6 12L2 15V17C2 18.1 2.9 19 4 19H14" fill="transparent" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"></path>
    <path d="M7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8Z"
          fill="transparent" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"></path>
    <path d="M17 19H23" fill="transparent" stroke="currentColor" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"></path>
    <path d="M20 16V22" fill="transparent" stroke="currentColor" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"></path>
  </symbol>
  <symbol fill="none" id="image-edit" viewBox="0 0 24 24">
    <path clip-rule="evenodd" d="M22 13V4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V14V16C2 17.1 2.9 18 4 18H14"
          fill="transparent" fill-rule="evenodd"
          stroke="currentColor" stroke-width="1.5"></path>
    <path d="M22 13V4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V14V16C2 17.1 2.9 18 4 18H14" fill="transparent"
          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"></path>
    <path clip-rule="evenodd" d="M22 13L17 7L11 15L6 11L2 14V16C2 17.1 2.9 18 4 18H14" fill="transparent"
          fill-rule="evenodd" stroke="currentColor" stroke-width="1.5"></path>
    <path d="M22 13L17 7L11 15L6 11L2 14V16C2 17.1 2.9 18 4 18H14" fill="transparent" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"></path>
    <path d="M7 7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7Z"
          fill="transparent" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"></path>
    <path d="M19.8398 15.6L17.3598 19.89L17.2998 21L18.2198 20.39L20.6998 16.1L19.8398 15.6Z" fill="transparent"
          stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5"></path>
  </symbol>

  <symbol class="feather feather-inbox" fill="none" id="no-data" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
    <path
      d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
  </symbol>
  <symbol fill="none" id="payments" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <rect height="16" rx="2" ry="2" width="22" x="1" y="4"/>
    <path d="M1 10h22"/>
  </symbol>
  <symbol id="remove" viewBox="0 0 24 24">
    <path d="M3 6h18m-2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-6 5v6m4-6v6"/>
  </symbol>
  <symbol class="css-i6dzq1" fill="none" id="block" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="4.93" x2="19.07" y1="4.93" y2="19.07"></line>
  </symbol>
  <symbol id="program" viewBox="0 0 24 24">
    <path d="M4 17l6-6-6-6m8 14h8"/>
  </symbol>
  <symbol id="tree" preserveAspectRatio="xMidYMid meet" viewBox="0 0 36 36">
    <rect class="clr-i-solid clr-i-solid-path-1" fill="currentColor" height="6" rx="1" ry="1" width="6" x="10"
          y="26"></rect>
    <path
      class="clr-i-solid clr-i-solid-path-2"
      d="M15 16h-4a1 1 0 0 0-1 1v1.2H5.8V12H7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1.2v17.8H11a.8.8 0 1 0 0-1.6H5.8v-8.4H10V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z" fill="currentColor"></path>
    <path class="clr-i-solid clr-i-solid-path-3" d="M33 8H10v2h23a1 1 0 0 0 0-2z" fill="currentColor"></path>
    <path class="clr-i-solid clr-i-solid-path-4" d="M33 18H18v2h15a1 1 0 0 0 0-2z" fill="currentColor"></path>
    <path class="clr-i-solid clr-i-solid-path-5" d="M33 28H18v2h15a1 1 0 0 0 0-2z" fill="currentColor"></path>
  </symbol>
  <symbol id="syllabus" viewBox="0 0 24 24">
    <path
      d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 0 0-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55c.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75s-.75-.34-.75-.75s.34-.75.75-.75zM19 19H5V5h14v14z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="details-icon" viewBox="0 0 24 24">
    <path class="uim-tertiary" d="M11 8H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm0 4H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z"
          fill="currentColor" opacity="1"></path>
    <rect class="uim-primary" fill="currentColor" height="8" rx="1" width="8" x="14" y="4"></rect>
    <path class="uim-tertiary" d="M21 16H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm-8 4H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z"
          fill="currentColor" opacity="1"></path>
  </symbol>
  <symbol id="two-arrows-up" viewBox="0 0 24 24">
    <path d="M17 11l-5-5-5 5m10 7l-5-5-5 5"/>
  </symbol>
  <symbol fill="none" id="visible" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </symbol>
  <symbol fill="none" id="user" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </symbol>
  <symbol class="feather feather-chevron-down" fill="none" id="arrow-down" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <polyline points="6 9 12 15 18 9"></polyline>
  </symbol>
  <symbol fill="none" id="arrow-left" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M19 12H5m7 7l-7-7 7-7"/>
  </symbol>
  <symbol fill="none" id="time-clock" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24">
    <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
  </symbol>
  <symbol fill="none" id="search" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8"/>
    <path d="M21 21l-4.35-4.35"/>
  </symbol>
  <symbol fill="none" id="add-circle" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 8v8m-4-4h8"/>
  </symbol>
  <symbol id="acc-expand" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M10 21v-2H6.41l4.5-4.5l-1.41-1.41l-4.5 4.5V14H3v7h7m4.5-10.09l4.5-4.5V10h2V3h-7v2h3.59l-4.5 4.5l1.41 1.41z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="acc-collapse" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M19.5 3.09L15 7.59V4h-2v7h7V9h-3.59l4.5-4.5l-1.41-1.41M4 13v2h3.59l-4.5 4.5l1.41 1.41l4.5-4.5V20h2v-7H4z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="expand-ac" viewBox="0 0 21.84 18.753">
    <g transform="translate(-0.001 0)">
      <path d="M22.5,29.25h4.68v1.56H22.5Z" transform="translate(-8.459 -12.057)"/>
      <path d="M22.5,20.25h6.24v1.56H22.5Z" transform="translate(-8.459 -9.298)"/>
      <path d="M22.5,11.25h7.8v1.56H22.5Z" transform="translate(-8.459 -6.538)"/>
      <path d="M16.875,4.5h1.56V23.22h-1.56Z" transform="translate(-6.734 -4.468)"/>
      <path d="M8.947,4.454,6.15,7.02l-2.8-2.567-1.1,1.1,3.9,3.609,3.9-3.609Z" transform="translate(-2.249 -4.453)"/>
    </g>
  </symbol>

  <symbol id="collapse-ac" viewBox="0 0 18.268 21.84">
    <g transform="translate(0)">
      <path d="M15.75,28.125H26.67v1.56H15.75Z" fill="#0036ff" transform="translate(-8.402 -10.185)"/>
      <path d="M7.173,27.87,5.161,29.882l1.1,1.108,3.12-3.12L6.26,24.75l-1.107,1.1Z" fill="#0036ff"
            transform="translate(-5.153 -9.15)"/>
      <path d="M15.75,16.875H26.67v1.56H15.75Z" fill="#0036ff" transform="translate(-8.402 -6.735)"/>
      <path d="M7.173,16.62,5.161,18.632l1.1,1.108,3.12-3.12L6.26,13.5,5.153,14.6Z" fill="#0036ff"
            transform="translate(-5.153 -5.7)"/>
      <path d="M15.75,5.625H26.67v1.56H15.75Z" fill="#0036ff" transform="translate(-8.402 -3.285)"/>
      <path d="M7.173,5.37,5.161,7.382,6.26,8.49,9.38,5.37,6.26,2.25,5.153,3.35Z" fill="#0036ff"
            transform="translate(-5.153 -2.25)"/>
    </g>
  </symbol>


  <symbol class="css-i6dzq1" fill="none" id="add" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <line x1="12" x2="12" y1="5" y2="19"></line>
    <line x1="5" x2="19" y1="12" y2="12"></line>
  </symbol>

  <symbol fill="currentColor" id="settings" viewBox="0 0 512 512">
    <path
      d="M456.7 242.27l-26.08-4.2a8 8 0 01-6.6-6.82c-.5-3.2-1-6.41-1.7-9.51a8.08 8.08 0 013.9-8.62l23.09-12.82a8.05 8.05 0 003.9-9.92l-4-11a7.94 7.94 0 00-9.4-5l-25.89 5a8 8 0 01-8.59-4.11q-2.25-4.2-4.8-8.41a8.16 8.16 0 01.7-9.52l17.29-19.94a8 8 0 00.3-10.62l-7.49-9a7.88 7.88 0 00-10.5-1.51l-22.69 13.63a8 8 0 01-9.39-.9c-2.4-2.11-4.9-4.21-7.4-6.22a8 8 0 01-2.5-9.11l9.4-24.75A8 8 0 00365 78.77l-10.2-5.91a8 8 0 00-10.39 2.21l-16.64 20.84a7.15 7.15 0 01-8.5 2.5s-5.6-2.3-9.8-3.71A8 8 0 01304 87l.4-26.45a8.07 8.07 0 00-6.6-8.42l-11.59-2a8.07 8.07 0 00-9.1 5.61l-8.6 25.05a8 8 0 01-7.79 5.41h-9.8a8.07 8.07 0 01-7.79-5.41l-8.6-25.05a8.07 8.07 0 00-9.1-5.61l-11.59 2a8.07 8.07 0 00-6.6 8.42l.4 26.45a8 8 0 01-5.49 7.71c-2.3.9-7.3 2.81-9.7 3.71-2.8 1-6.1.2-8.8-2.91l-16.51-20.34A8 8 0 00156.75 73l-10.2 5.91a7.94 7.94 0 00-3.3 10.09l9.4 24.75a8.06 8.06 0 01-2.5 9.11c-2.5 2-5 4.11-7.4 6.22a8 8 0 01-9.39.9L111 116.14a8 8 0 00-10.5 1.51l-7.49 9a8 8 0 00.3 10.62l17.29 19.94a8 8 0 01.7 9.52q-2.55 4-4.8 8.41a8.11 8.11 0 01-8.59 4.11l-25.89-5a8 8 0 00-9.4 5l-4 11a8.05 8.05 0 003.9 9.92L85.58 213a7.94 7.94 0 013.9 8.62c-.6 3.2-1.2 6.31-1.7 9.51a8.08 8.08 0 01-6.6 6.82l-26.08 4.2a8.09 8.09 0 00-7.1 7.92v11.72a7.86 7.86 0 007.1 7.92l26.08 4.2a8 8 0 016.6 6.82c.5 3.2 1 6.41 1.7 9.51a8.08 8.08 0 01-3.9 8.62L62.49 311.7a8.05 8.05 0 00-3.9 9.92l4 11a7.94 7.94 0 009.4 5l25.89-5a8 8 0 018.59 4.11q2.25 4.2 4.8 8.41a8.16 8.16 0 01-.7 9.52l-17.29 19.96a8 8 0 00-.3 10.62l7.49 9a7.88 7.88 0 0010.5 1.51l22.69-13.63a8 8 0 019.39.9c2.4 2.11 4.9 4.21 7.4 6.22a8 8 0 012.5 9.11l-9.4 24.75a8 8 0 003.3 10.12l10.2 5.91a8 8 0 0010.39-2.21l16.79-20.64c2.1-2.6 5.5-3.7 8.2-2.6 3.4 1.4 5.7 2.2 9.9 3.61a8 8 0 015.49 7.71l-.4 26.45a8.07 8.07 0 006.6 8.42l11.59 2a8.07 8.07 0 009.1-5.61l8.6-25a8 8 0 017.79-5.41h9.8a8.07 8.07 0 017.79 5.41l8.6 25a8.07 8.07 0 009.1 5.61l11.59-2a8.07 8.07 0 006.6-8.42l-.4-26.45a8 8 0 015.49-7.71c4.2-1.41 7-2.51 9.6-3.51s5.8-1 8.3 2.1l17 20.94A8 8 0 00355 439l10.2-5.91a7.93 7.93 0 003.3-10.12l-9.4-24.75a8.08 8.08 0 012.5-9.12c2.5-2 5-4.1 7.4-6.21a8 8 0 019.39-.9L401 395.66a8 8 0 0010.5-1.51l7.49-9a8 8 0 00-.3-10.62l-17.29-19.94a8 8 0 01-.7-9.52q2.55-4.05 4.8-8.41a8.11 8.11 0 018.59-4.11l25.89 5a8 8 0 009.4-5l4-11a8.05 8.05 0 00-3.9-9.92l-23.09-12.82a7.94 7.94 0 01-3.9-8.62c.6-3.2 1.2-6.31 1.7-9.51a8.08 8.08 0 016.6-6.82l26.08-4.2a8.09 8.09 0 007.1-7.92V250a8.25 8.25 0 00-7.27-7.73zM256 112a143.82 143.82 0 01139.38 108.12A16 16 0 01379.85 240H274.61a16 16 0 01-13.91-8.09l-52.1-91.71a16 16 0 019.85-23.39A146.94 146.94 0 01256 112zM112 256a144 144 0 0143.65-103.41 16 16 0 0125.17 3.47L233.06 248a16 16 0 010 15.87l-52.67 91.7a16 16 0 01-25.18 3.36A143.94 143.94 0 01112 256zm144 144a146.9 146.9 0 01-38.19-4.95 16 16 0 01-9.76-23.44l52.58-91.55a16 16 0 0113.88-8H379.9a16 16 0 0115.52 19.88A143.84 143.84 0 01256 400z"></path>
  </symbol>

  <symbol class="css-i6dzq1" fill="none" id="more" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </symbol>

  <symbol
    fill="none"
    id="play-no-circle"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M15 12.3301L9 16.6603L9 8L15 12.3301Z" fill="currentColor"/>
  </symbol>

  <symbol class="glyph" id="play-icon" viewBox="0 0 27 27">
    <path
      d="M11.3545232,18.4180929 L18.4676039,14.242665 C19.0452323,13.9290954 19.0122249,13.1204156 18.4676039,12.806846 L11.3545232,8.63141809 C10.7603912,8.26833741 9.98471883,8.54889976 9.98471883,9.19254279 L9.98471883,17.8404645 C9.98471883,18.5006112 10.7108802,18.7976773 11.3545232,18.4180929 Z"></path>
  </symbol>

  <symbol fill="none" id="warning-alert" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" x2="12" y1="9" y2="13"></line>
    <line x1="12" x2="12.01" y1="17" y2="17"></line>
  </symbol>
  <symbol fill="none" id="airplay" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          viewBox="0 0 24 24">
    <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
    <polygon points="12 15 17 21 7 21 12 15"></polygon>
  </symbol>

  <symbol fill="currentColor" id="checkmark" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          fill-rule="evenodd"></path>
  </symbol>

  <symbol fill="none" id="icon-quiz" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>
  <symbol fill="none" id="content-quiz" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>
  <symbol fill="none" id="practice-quiz" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="1.5"></path>
  </symbol>
  <symbol fill="none" id="graded-quiz" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          viewBox="0 0 24 24">
    <line x1="8" x2="21" y1="6" y2="6"></line>
    <line x1="8" x2="21" y1="12" y2="12"></line>
    <line x1="8" x2="21" y1="18" y2="18"></line>
    <line x1="3" x2="3.01" y1="6" y2="6"></line>
    <line x1="3" x2="3.01" y1="12" y2="12"></line>
    <line x1="3" x2="3.01" y1="18" y2="18"></line>
  </symbol>
  <symbol fill="none" id="checkmark-circle" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>
  <symbol class="css-i6dzq1" fill="none" id="check-mark" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </symbol>
  <symbol fill="currentColor" id="remove-circle" viewBox="0 0 20 20">
    <path clip-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="none" id="remove-circle-outline" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
  </symbol>

  <symbol fill="none" id="reorder" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          viewBox="0 0 24 24">
    <path d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
  </symbol>
  <symbol class="css-i6dzq1" fill="none" id="help" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" x2="12.01" y1="17" y2="17"></line>
  </symbol>
  <symbol id="issue-bug" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path
      d="M16.895 6.519l2.813-2.812l-1.414-1.414l-2.846 2.846a6.575 6.575 0 0 0-.723-.454a5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293L4.293 3.707l2.813 2.812A8.473 8.473 0 0 0 5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5c0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118c.188.555.421 1.093.695 1.6c.044.081.095.155.141.234l-2.33 2.33l1.414 1.414l2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58a6.515 6.515 0 0 0 3.237.001a6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904c.258-.218.5-.462.734-.716l2.111 2.111l1.414-1.414l-2.33-2.33c.047-.08.098-.155.142-.236c.273-.505.507-1.043.694-1.599c.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511c0-.503-.042-1.005-.106-1.5H22V9h-3.756a8.494 8.494 0 0 0-1.349-2.481zM8.681 7.748c.445-.558.96-.993 1.528-1.294a3.773 3.773 0 0 1 3.581 0a4.894 4.894 0 0 1 1.53 1.295c.299.373.54.8.753 1.251H7.927c.214-.451.454-.879.754-1.252zM17.8 12.5c0 .522-.042 1.044-.126 1.553c-.079.49-.199.973-.355 1.436a8.28 8.28 0 0 1-.559 1.288a7.59 7.59 0 0 1-.733 1.11c-.267.333-.56.636-.869.898c-.31.261-.639.484-.979.664s-.695.317-1.057.41c-.04.01-.082.014-.122.023V14h-2v5.881c-.04-.009-.082-.013-.122-.023c-.361-.093-.717-.23-1.057-.41s-.669-.403-.978-.664a6.462 6.462 0 0 1-.871-.899a7.402 7.402 0 0 1-.731-1.108a8.337 8.337 0 0 1-.56-1.289a9.075 9.075 0 0 1-.356-1.438A9.61 9.61 0 0 1 6.319 11H17.68c.079.491.12.995.12 1.5z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="issue-improvement" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 256 256">
    <path
      d="M232 208a8 8 0 0 1-8 8H32a8 8 0 0 1-8-8V48a8 8 0 0 1 16 0v108.688l50.345-50.345a8.001 8.001 0 0 1 11.315 0l26.342 26.344L188.688 72h-20.686a8 8 0 0 1 0-16h40c.264 0 .527.014.79.04c.118.011.232.034.349.05c.142.02.284.037.425.065c.132.026.26.063.39.095c.124.031.248.059.37.095c.127.039.25.087.374.132c.122.043.244.083.364.133c.115.047.226.103.337.156c.126.059.252.114.374.18c.104.056.203.12.305.18c.123.073.247.143.367.223c.108.072.209.153.313.23c.106.079.213.152.316.236c.165.136.321.282.475.43c.035.034.073.063.109.098c.037.037.069.079.105.117c.146.15.289.304.422.466c.087.106.164.218.245.328c.073.1.151.197.22.3c.084.125.157.254.232.382c.057.096.118.19.171.29c.069.127.127.259.189.39c.05.106.102.21.148.319c.052.126.094.255.14.383c.042.119.088.235.124.356c.04.13.068.26.1.39c.032.123.066.245.091.37c.03.151.049.305.07.458c.015.105.035.21.045.316c.027.265.04.531.04.797V104a8 8 0 0 1-16 0V83.314l-66.342 66.343a8.001 8.001 0 0 1-11.315 0l-26.343-26.344L40 179.317V200h184a8 8 0 0 1 8 8z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="issue-feature" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 15 15">
    <g fill="none">
      <path
        d="M4.076 6.47l.495.07l-.495-.07zm-.01.07l-.495-.07l.495.07zm6.858-.07l.495-.07l-.495.07zm.01.07l-.495.07l.495-.07zM9.5 12.5v.5a.5.5 0 0 0 .5-.5h-.5zm-4 0H5a.5.5 0 0 0 .5.5v-.5zm-.745-3.347l.396-.306l-.396.306zm5.49 0l-.396-.306l.396.306zM6 15h3v-1H6v1zM3.58 6.4l-.01.07l.99.14l.01-.07l-.99-.14zM7.5 3a3.959 3.959 0 0 0-3.92 3.4l.99.14A2.959 2.959 0 0 1 7.5 4V3zm3.92 3.4A3.959 3.959 0 0 0 7.5 3v1a2.96 2.96 0 0 1 2.93 2.54l.99-.14zm.01.07l-.01-.07l-.99.14l.01.07l.99-.14zm-.79 2.989c.63-.814.948-1.875.79-2.99l-.99.142a2.951 2.951 0 0 1-.59 2.236l.79.612zM9 10.9V12.5h1v-1.599H9zM9.5 12h-4v1h4v-1zm-3.5.5v-1.599H5V12.5h1zM3.57 6.47a3.951 3.951 0 0 0 .79 2.989l.79-.612a2.951 2.951 0 0 1-.59-2.236l-.99-.142zM6 10.9c0-.823-.438-1.523-.85-2.054l-.79.612c.383.495.64.968.64 1.442h1zm3.85-2.054C9.437 9.378 9 10.077 9 10.9h1c0-.474.257-.947.64-1.442l-.79-.612zM7 0v2h1V0H7zM0 8h2V7H0v1zm13 0h2V7h-2v1zM3.354 3.646l-1.5-1.5l-.708.708l1.5 1.5l.708-.708zm9 .708l1.5-1.5l-.708-.708l-1.5 1.5l.708.708z"
        fill="currentColor"></path>
    </g>
  </symbol>
  <symbol fill="none" id="copy-clipboard" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>
  <symbol fill="none" id="alarm-clock" stroke="currentColor" stroke-linecap="round"
          stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z"
      stroke-linejoin="round"></path>
    <path d="M18.6699 2L21.9999 5.33" stroke-linejoin="round" stroke-miterlimit="10"></path>
    <path d="M2 5.33L5.33 2" stroke-miterlimit="10"></path>
    <path d="M13 13H17"></path>
    <path d="M12 7V12"></path>
    <path
      d="M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
      fill="none"></path>
  </symbol>

  <symbol fill="none" id="information-circle" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2"></path>
  </symbol>

  <symbol fill="none" id="folder-outline" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
  </symbol>

  <symbol fill="currentColor" id="check-filled" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="currentColor" id="play-filled" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol fill="currentColor" id="pause-filled" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
          fill-rule="evenodd"></path>
  </symbol>
  <symbol id="file-ppsx" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#f8318a"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.813,0H14.659V-12.955h6.563c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H2.813ZM14.659-22.159V-34.176h4.176c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM42.188,0H54.034V-12.955H60.6c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H42.188ZM54.034-22.159V-34.176H58.21c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM105.085-30H116.42c-.043-8.565-6.648-14.233-17.216-14.233-10.376,0-17.706,5.582-17.642,13.892-.021,6.818,4.709,10.611,12.443,12.273l4.347.938c4.858,1.065,6.52,2.28,6.563,4.261-.043,2.152-2,3.665-5.8,3.665-4.538,0-7.223-2.131-7.415-6.136H80.455C80.5-4.389,87.912.511,99.29.511c11.058,0,17.685-4.773,17.727-13.381-.043-6.648-4.006-11.314-13.636-13.381l-3.58-.767c-4.134-.874-5.987-2.088-5.881-4.176.021-1.918,1.619-3.324,5.284-3.324C103.04-34.517,104.851-32.834,105.085-30Zm29.148-13.636h-13.3l12.955,21.818L120.511,0h13.466l7.415-12.955h.341L149.148,0H162.7L149.148-21.818l13.04-21.818h-13.21l-7.244,12.7h-.341Z"
        fill="#e9edf4" transform="translate(174 446)"/>
    </g>
  </symbol>
  <symbol id="file-pptx" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#d54b27"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.813,0H14.659V-12.955h6.563c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H2.813ZM14.659-22.159V-34.176h4.176c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM42.188,0H54.034V-12.955H60.6c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H42.188ZM54.034-22.159V-34.176H58.21c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM80.369-34.091H93.494V0H105.17V-34.091H118.3v-9.545H80.369Zm55.057-9.545h-13.3l12.955,21.818L121.7,0H135.17l7.415-12.955h.341L150.341,0h13.551L150.341-21.818l13.04-21.818H150.17l-7.244,12.7h-.341Z"
        fill="#e9edf4" transform="translate(173 446)"/>
    </g>
  </symbol>
  <symbol id="file-txt" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#d8d8d8"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M1.619-34.091H14.744V0H26.42V-34.091H39.545v-9.545H1.619Zm55.057-9.545h-13.3L56.335-21.818,42.955,0H56.42l7.415-12.955h.341L71.591,0H85.142L71.591-21.818l13.04-21.818H71.42l-7.244,12.7h-.341Zm31.875,9.545h13.125V0h11.676V-34.091h13.125v-9.545H88.551Z"
        fill="#333" transform="translate(192 446)"/>
    </g>
  </symbol>
  <symbol id="file-rtf" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#cdcdcd"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.813,0H14.659V-14.4H18.75L26.42,0H39.29L30.426-16.278c4.645-2.237,7.415-6.477,7.415-12.528,0-9.29-6.5-14.83-16.193-14.83H2.813ZM14.659-23.608V-34.176h4.176c4.155,0,6.648,1.619,6.648,5.369,0,3.729-2.493,5.2-6.648,5.2ZM41.676-34.091H54.8V0H66.477V-34.091H79.6v-9.545H41.676ZM84.034,0H95.881V-17.045h16.96v-9.545H95.881v-7.5h18.835v-9.545H84.034Z"
        fill="#333" transform="translate(198 446)"/>
    </g>
  </symbol>
  <symbol id="file-doc" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#cdcdcd"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M19.6,0C32.9,0,41.335-8.182,41.335-21.818S32.9-43.636,19.432-43.636H2.813V0ZM14.659-10.057V-33.58h4.176c6.818,0,10.568,2.642,10.568,11.761s-3.75,11.761-10.227,11.761Zm74.4-11.761c0-14.574-9.375-22.415-21.222-22.415-11.932,0-21.222,7.841-21.222,22.415C46.619-7.33,55.909.6,67.841.6,79.688.6,89.063-7.244,89.063-21.818Zm-12.187,0c0,7.841-3.153,12.1-9.034,12.1s-9.034-4.261-9.034-12.1,3.153-12.1,9.034-12.1S76.875-29.659,76.875-21.818Zm58.381-5.455c-.937-10.824-8.864-16.96-19.858-16.96-11.761,0-21.051,7.841-21.051,22.415C94.347-7.308,103.381.6,115.4.6c12.784,0,19.261-8.864,19.858-16.278l-12.017-.085c-.6,3.729-3.239,6.051-7.585,6.051-5.774,0-9.119-4.091-9.119-12.1,0-7.585,3.239-12.1,9.2-12.1,4.56,0,7.159,2.685,7.5,6.648Z"
        fill="#333" transform="translate(187 446)"/>
    </g>
  </symbol>
  <symbol id="file-xls" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#3ab75d"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M15.511-43.636H2.216L15.17-21.818,1.79,0H15.256L22.67-12.955h.341L30.426,0H43.977L30.426-21.818l13.04-21.818H30.256l-7.244,12.7H22.67ZM48.58,0H78.068V-9.545H60.426V-43.636H48.58Zm57.784-30H117.7c-.043-8.565-6.648-14.233-17.216-14.233-10.376,0-17.706,5.582-17.642,13.892C82.82-23.523,87.55-19.73,95.284-18.068l4.347.938c4.858,1.065,6.52,2.28,6.563,4.261-.043,2.152-2,3.665-5.8,3.665-4.538,0-7.223-2.131-7.415-6.136H81.733C81.776-4.389,89.19.511,100.568.511c11.058,0,17.685-4.773,17.727-13.381-.043-6.648-4.006-11.314-13.636-13.381l-3.58-.767c-4.134-.874-5.987-2.088-5.881-4.176.021-1.918,1.619-3.324,5.284-3.324C104.318-34.517,106.129-32.834,106.364-30Z"
        fill="#e9edf4" transform="translate(196 446)"/>
    </g>
  </symbol>

  <symbol id="file-null" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#d8d8d8"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
    </g>
  </symbol>
  <symbol id="file-mp4" viewBox="0 0 368 464">
    <g id="mp4" transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#ecf0ff"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#2653f6"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#2653f6"/>
      <path
        d="M3.75-58.182V0H19.2V-33.864h.455L32.614-.455h9.318L54.886-33.636h.455V0H70.8V-58.182H51.136L37.614-25.227h-.682L23.409-58.182ZM78.3,0h15.8V-17.273h8.75c13.267,0,22.159-7.812,22.159-20.341,0-12.386-8.665-20.568-21.591-20.568H78.3Zm15.8-29.545V-45.568h5.568c5.54,0,8.864,2.955,8.864,7.955,0,4.972-3.324,8.068-8.864,8.068Zm36.25,20.455h28.3V0H173.75V-9.091h6.7V-21.364h-6.7V-58.182h-20L130.341-21.364Zm28.636-12.273H145.909v-.455l12.614-20h.455Z"
        fill="#e9edf4" transform="translate(165 454)"/>
      <circle cx="96" cy="96" fill="#2653f6" r="96" transform="translate(160 104)"/>
      <g>
        <path d="M232,232V168l64,32Z" fill="#ecf0ff"/>
      </g>
    </g>
  </symbol>
  <symbol id="file-zip" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#fde48f"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.983,0H38.608V-9.545H18.068L38.693-37.074v-6.562H3.068v9.545h20.54L2.983-6.562ZM56.335-43.636H44.489V0H56.335ZM61.96,0H73.807V-12.955h6.563c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H61.96ZM73.807-22.159V-34.176h4.176c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051Z"
        fill="#333" transform="translate(207 446)"/>
    </g>
  </symbol>
  <symbol id="file-ppt" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#d54b27"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.813,0H14.659V-12.955h6.563c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H2.813ZM14.659-22.159V-34.176h4.176c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM42.188,0H54.034V-12.955H60.6c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H42.188ZM54.034-22.159V-34.176H58.21c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM105.085-30H116.42c-.043-8.565-6.648-14.233-17.216-14.233-10.376,0-17.706,5.582-17.642,13.892-.021,6.818,4.709,10.611,12.443,12.273l4.347.938c4.858,1.065,6.52,2.28,6.563,4.261-.043,2.152-2,3.665-5.8,3.665-4.538,0-7.223-2.131-7.415-6.136H80.455C80.5-4.389,87.912.511,99.29.511c11.058,0,17.685-4.773,17.727-13.381-.043-6.648-4.006-11.314-13.636-13.381l-3.58-.767c-4.134-.874-5.987-2.088-5.881-4.176.021-1.918,1.619-3.324,5.284-3.324C103.04-34.517,104.851-32.834,105.085-30Z"
        fill="#e9edf4" transform="translate(197 446)"/>
    </g>
  </symbol>


  <symbol id="file-docx" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#3085f3"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M19.6,0C32.9,0,41.335-8.182,41.335-21.818S32.9-43.636,19.432-43.636H2.813V0ZM14.659-10.057V-33.58h4.176c6.818,0,10.568,2.642,10.568,11.761s-3.75,11.761-10.227,11.761Zm74.4-11.761c0-14.574-9.375-22.415-21.222-22.415-11.932,0-21.222,7.841-21.222,22.415C46.619-7.33,55.909.6,67.841.6,79.688.6,89.063-7.244,89.063-21.818Zm-12.187,0c0,7.841-3.153,12.1-9.034,12.1s-9.034-4.261-9.034-12.1,3.153-12.1,9.034-12.1S76.875-29.659,76.875-21.818Zm58.381-5.455c-.937-10.824-8.864-16.96-19.858-16.96-11.761,0-21.051,7.841-21.051,22.415C94.347-7.308,103.381.6,115.4.6c12.784,0,19.261-8.864,19.858-16.278l-12.017-.085c-.6,3.729-3.239,6.051-7.585,6.051-5.774,0-9.119-4.091-9.119-12.1,0-7.585,3.239-12.1,9.2-12.1,4.56,0,7.159,2.685,7.5,6.648Zm16.7-16.364h-13.3l12.955,21.818L138.239,0H151.7l7.415-12.955h.341L166.875,0h13.551L166.875-21.818l13.04-21.818H166.7l-7.244,12.7h-.341Z"
        fill="#e9edf4" transform="translate(165 446)"/>
    </g>
  </symbol>

  <symbol id="file-xlsx" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#58C472"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path d="M15.511-43.636H2.216L15.17-21.818,1.79,0H15.256L22.67-12.955h.341L30.426,0H43.977L30.426-21.818l13.04-21.818H30.256l-7.244,12.7H22.67ZM48.58,0H78.068V-9.545H60.426V-43.636H48.58Zm57.784-30H117.7c-.043-8.565-6.648-14.233-17.216-14.233-10.376,0-17.706,5.582-17.642,13.892C82.82-23.523,87.55-19.73,95.284-18.068l4.347.938c4.858,1.065,6.52,2.28,6.563,4.261-.043,2.152-2,3.665-5.8,3.665-4.538,0-7.223-2.131-7.415-6.136H81.733C81.776-4.389,89.19.511,100.568.511c11.058,0,17.685-4.773,17.727-13.381-.043-6.648-4.006-11.314-13.636-13.381l-3.58-.767c-4.134-.874-5.987-2.088-5.881-4.176.021-1.918,1.619-3.324,5.284-3.324C104.318-34.517,106.129-32.834,106.364-30Zm29.148-13.636h-13.3L135.17-21.818,121.79,0h13.466l7.415-12.955h.341L150.426,0h13.551L150.426-21.818l13.04-21.818h-13.21l-7.244,12.7h-.341Z"
            fill="#E9EDF4"
            transform="translate(173 446)"/>
    </g>
  </symbol>
  <symbol id="file-pdf" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#ee4135"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.813,0H14.659V-12.955h6.563c9.95,0,16.619-5.859,16.619-15.256,0-9.29-6.5-15.426-16.193-15.426H2.813ZM14.659-22.159V-34.176h4.176c4.155,0,6.648,2.216,6.648,5.966,0,3.729-2.493,6.051-6.648,6.051ZM58.977,0C72.273,0,80.71-8.182,80.71-21.818s-8.437-21.818-21.9-21.818H42.188V0ZM54.034-10.057V-33.58H58.21c6.818,0,10.568,2.642,10.568,11.761s-3.75,11.761-10.227,11.761ZM86.165,0H98.011V-17.045h16.96v-9.545H98.011v-7.5h18.835v-9.545H86.165Z"
        fill="#e9edf4" transform="translate(197 446)"/>
    </g>
  </symbol>
  <symbol id="file-rar" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#5c147c"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M2.813,0H14.659V-14.4H18.75L26.42,0H39.29L30.426-16.278c4.645-2.237,7.415-6.477,7.415-12.528,0-9.29-6.5-14.83-16.193-14.83H2.813ZM14.659-23.608V-34.176h4.176c4.155,0,6.648,1.619,6.648,5.369,0,3.729-2.493,5.2-6.648,5.2ZM54.2,0l2.514-8.352h14.4L73.636,0H86.42l-14.4-43.636H55.824L41.42,0Zm5.2-17.216,4.347-14.4h.341l4.347,14.4ZM90.6,0h11.847V-14.4h4.091L114.2,0h12.869L118.21-16.278c4.645-2.237,7.415-6.477,7.415-12.528,0-9.29-6.5-14.83-16.193-14.83H90.6Zm11.847-23.608V-34.176h4.176c4.155,0,6.648,1.619,6.648,5.369,0,3.729-2.493,5.2-6.648,5.2Z"
        fill="#e9edf4" transform="translate(192 446)"/>
    </g>
  </symbol>
  <symbol id="file-csv" viewBox="0 0 368 464">
    <g transform="translate(-72 -24)">
      <path d="M392,488H120a48,48,0,0,1-48-48V72a48,48,0,0,1,48-48H344l96,96V440A48,48,0,0,1,392,488Z" fill="#f6f6f6"/>
      <path d="M72,360H440v80a48,48,0,0,1-48,48H120a48,48,0,0,1-48-48Z" fill="#107c41"/>
      <path d="M440,120H392a48,48,0,0,1-48-48V24Z" fill="#cdcdcd"/>
      <path
        d="M43.551-27.273c-.937-10.824-8.864-16.96-19.858-16.96-11.761,0-21.051,7.841-21.051,22.415C2.642-7.308,11.676.6,23.693.6,36.477.6,42.955-8.267,43.551-15.682l-12.017-.085c-.6,3.729-3.239,6.051-7.585,6.051-5.774,0-9.119-4.091-9.119-12.1,0-7.585,3.239-12.1,9.2-12.1,4.56,0,7.159,2.685,7.5,6.648ZM72.443-30H83.778c-.043-8.565-6.648-14.233-17.216-14.233-10.376,0-17.706,5.582-17.642,13.892C48.9-23.523,53.629-19.73,61.364-18.068l4.347.938c4.858,1.065,6.52,2.28,6.563,4.261-.043,2.152-2,3.665-5.8,3.665-4.538,0-7.223-2.131-7.415-6.136H47.813C47.855-4.389,55.27.511,66.648.511c11.058,0,17.685-4.773,17.727-13.381-.043-6.648-4.006-11.314-13.636-13.381l-3.58-.767c-4.134-.874-5.987-2.088-5.881-4.176.021-1.918,1.619-3.324,5.284-3.324C70.4-34.517,72.209-32.834,72.443-30Zm28.381-13.636H87.443L101.847,0H118.04l14.4-43.636H119.063l-8.949,30.767h-.341Z"
        fill="#e9edf4" transform="translate(189 446)"/>
    </g>
  </symbol>

  <symbol class="css-i6dzq1" fill="none" id="report-icon" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="2" viewBox="0 0 24 24">
    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
    <line x1="15" x2="9" y1="9" y2="15"></line>
    <line x1="9" x2="15" y1="9" y2="15"></line>
  </symbol>

  <symbol class="feather feather-image" fill="none" id="picture-icon" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <rect height="18" rx="2" ry="2" width="18" x="3" y="3"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21 15 16 10 5 21"></polyline>
  </symbol>
  <symbol id="move-to-bottom" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 24 24">
    <path d="M19.92 12.08L12 20l-7.92-7.92l1.42-1.41l5.5 5.5V2h2v14.17l5.5-5.51l1.42 1.42M12 20H2v2h20v-2H12z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="move-to-top" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path d="M4.08 11.92L12 4l7.92 7.92l-1.42 1.41l-5.5-5.5V22h-2V7.83l-5.5 5.5l-1.42-1.41M12 4h10V2H2v2h10z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="move-up" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path d="M13 20h-2V8l-5.5 5.5l-1.42-1.42L12 4.16l7.92 7.92l-1.42 1.42L13 8v12z" fill="currentColor"></path>
  </symbol>
  <symbol id="move-down" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path d="M11 4h2v12l5.5-5.5l1.42 1.42L12 19.84l-7.92-7.92L5.5 10.5L11 16V4z" fill="currentColor"></path>
  </symbol>

  <symbol id="mark-as-check" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);" viewBox="0 0 24 24">
    <path
      d="M19 19H5V5h10V3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8h-2m-11.09-.92L6.5 11.5L11 16L21 6l-1.41-1.42L11 13.17l-3.09-3.09z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="mark-as-uncheck" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 24 24">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="mark-as-active" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 24 24">
    <path
      d="M.41 13.41L6 19l1.41-1.42L1.83 12m20.41-6.42L11.66 16.17L7.5 12l-1.43 1.41L11.66 19l12-12M18 7l-1.41-1.42l-6.35 6.35l1.42 1.41L18 7z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="mark-as-unactive" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 24 24">
    <path d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"
          fill="currentColor"></path>
  </symbol>
  <symbol id="user-role-privilege" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 24 24">
    <path
      d="M17 11c.34 0 .67.04 1 .09V6.27L10.5 3L3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82c.55-.13 1.08-.32 1.6-.55c-.69-.98-1.1-2.17-1.1-3.45c0-3.31 2.69-6 6-6z"
      fill="currentColor"></path>
    <path
      d="M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4zm0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12s-1.12-.51-1.12-1.12s.5-1.12 1.12-1.12zm0 5.37c-.93 0-1.74-.46-2.24-1.17c.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="user-role-privilege-1" preserveAspectRatio="xMidYMid meet" style="transform: rotate(360deg);"
          viewBox="0 0 26 26">
    <path
      d="M23.633 5.028a1.074 1.074 0 0 0-.777-.366c-2.295-.06-5.199-2.514-7.119-3.477C14.551.592 13.768.201 13.18.098a1.225 1.225 0 0 0-.36.001c-.588.103-1.371.494-2.556 1.087c-1.92.962-4.824 3.417-7.119 3.476a1.08 1.08 0 0 0-.778.366a1.167 1.167 0 0 0-.291.834c.493 10.023 4.088 16.226 10.396 19.831c.164.093.346.141.527.141s.363-.048.528-.141c6.308-3.605 9.902-9.808 10.396-19.831a1.161 1.161 0 0 0-.29-.834zm-5.57 10.249c0 1.36-2.604 1.67-5.048 1.67c-2.44 0-5.077-.31-5.077-1.67v-.374c0-.999 1.8-2.011 3.333-2.564c.111-.041.641-.329.345-1.106c-.76-.775-1.334-2.034-1.334-3.271c0-1.896 1.254-2.889 2.719-2.889s2.726.993 2.726 2.889c0 1.232-.577 2.485-1.332 3.264h.003c-.289.881.174 1.09.248 1.114c1.61.532 3.418 1.536 3.418 2.564l-.001.373z"
      fill="currentColor"></path>
  </symbol>
  <symbol
    id="star-filled"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24">
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2L9.19 8.62L2 9.24l5.45 4.73L5.82 21L12 17.27z"
          fill="currentColor">
    </path>
  </symbol>
  <symbol class="feather feather-bookmark" fill="none" id="star-outline" stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2L9.19 8.62L2 9.24l5.45 4.73L5.82 21L12 17.27z"></path>
  </symbol>


  <symbol
    id="watch-later-add"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24">
    <path d="M2 16h8v-2H2m16 0v-4h-2v4h-4v2h4v4h2v-4h4v-2m-8-8H2v2h12m0 2H2v2h12v-2z" fill="currentColor"></path>
  </symbol>

  <symbol
    id="watch-later-added"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24">
    <path d="M14 10H2v2h12v-2m0-4H2v2h12V6M2 16h8v-2H2v2m19.5-4.5L23 13l-7 7l-4.5-4.5L13 14l3 3l5.5-5.5z"
          fill="currentColor"></path>
  </symbol>

  <symbol id="ns-eye-off" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
    <g fill="currentColor">
      <path
        d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288c-.335.48-.83 1.12-1.465 1.755c-.165.165-.337.328-.517.486l.708.709z"></path>
      <path
        d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"></path>
      <path
        d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884l-12-12l.708-.708l12 12l-.708.708z"></path>
    </g>
  </symbol>
  <symbol id="ns-eye-on" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
    <g fill="currentColor">
      <path
        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"></path>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0z"></path>
    </g>
  </symbol>
  <symbol fill="currentColor" id="search-arrow-right" viewBox="0 0 20 20">
    <path clip-rule="evenodd"
          d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
          fill-rule="evenodd"></path>
  </symbol>

  <symbol fill="currentColor" id="refresh" viewBox="0 0 24 24">
    <path
      d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6c0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6c0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4l-4-4v3z"
      fill="currentColor"></path>
  </symbol>

  <symbol fill="currentColor" id="burger" viewBox="0 0 29.799 20.693">
    <path d="M9824.589,3391.109h26.818a1.478,1.478,0,1,0,0-2.956h-26.818a1.478,1.478,0,1,0,0,2.956Zm26.818,5.912h-10.264a1.478,1.478,0,1,0,0,2.957h10.264a1.478,1.478,0,1,0,0-2.957Zm0,8.869h-18.541a1.478,1.478,0,1,0,0,2.957h18.541a1.478,1.478,0,1,0,0-2.957Z" data-name="menu 1058 copy 5"
          fill="currentColor"
          id="menu_1058_copy_5" transform="translate(-9823.099 -3388.153)"/>
  </symbol>


  <symbol fill="currentColor" height="14.998" id="comment" viewBox="0 0 14.998 14.998" width="14.998">
    <g id="bx-comment-detail" transform="translate(0 0)">
      <path d="M14,14h7.5v1.5H14Zm0,3h5.249v1.5H14Z" data-name="Path 531" id="Path_531"
            transform="translate(-10.251 -10.251)"/>
      <path d="M17.5,4H5.5A1.5,1.5,0,0,0,4,5.5V19l4-3h9.5A1.5,1.5,0,0,0,19,14.5v-9A1.5,1.5,0,0,0,17.5,4Zm0,10.5H7.5L5.5,16V5.5h12Z" data-name="Path 532"
            id="Path_532"
            transform="translate(-4 -4)"/>
    </g>
  </symbol>
  <symbol id="q-lowest" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M16 13h-3V3h-2v10H8l4 4l4-4zM4 19v2h16v-2H4z" fill="currentColor"></path>
  </symbol>
  <symbol id="q-average" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      d="M9.21 19H11v3c0 .55.45 1 1 1s1-.45 1-1v-3h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.2-.2-.51-.2-.71 0l-2.79 2.79a.5.5 0 0 0 .36.85zm5.58-14H13V2c0-.55-.45-1-1-1s-1 .45-1 1v3H9.21a.5.5 0 0 0-.36.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.32-.31.1-.85-.35-.85zM4 12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
      fill="currentColor"></path>
  </symbol>
  <symbol id="q-highest" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M8 11h3v10h2V11h3l-4-4l-4 4M4 3v2h16V3H4z" fill="currentColor"></path>
  </symbol>
</svg>
